import axios from 'axios'

const resource = '/signup'

export default {
  FetchCompany () {
    return axios.get(`${resource}/company`)
  },
  FetchPlans () {
    return axios.get(`${resource}/plans`)
  },
  FetchPackages () {
    return axios.get(`${resource}/packages`)
  },
  FetchDiscounts () {
    return axios.get(`${resource}/discounts`)
  },
  StoreAccount (payload) {
    return axios.post(`${resource}/create-account`, payload)
  },
  CreateIntent () {
    return axios.post(`${resource}/create-intent`)
  },
  StoreSubscription (payload) {
    return axios.post(`${resource}/create-subscription`, payload)
  }

}
